import { UiBlockType } from '../../../../ReactFlow/types';

const basePath = 'https://docs.notablehealth.com/platform-components/block-library';

export const documentationLinkByBlockType: Partial<Record<UiBlockType, string>> = {
  [UiBlockType.LlmPrompt]: `${basePath}/llm`,
  [UiBlockType.Evaluation]: `${basePath}/quality-evaluation`,
  [UiBlockType.HCCAlgorithmBlock]: `${basePath}/hcc-algorithm`,
  [UiBlockType.InformationExtraction]: `${basePath}/information-extraction`,
  [UiBlockType.OcrV2]: `${basePath}/ocr`,
  [UiBlockType.GetNotableObject]: `${basePath}/get-notable-object`,
  [UiBlockType.ScriptedFlow]: `${basePath}/script`,
  [UiBlockType.PatientDataStore]: `${basePath}/smart-fetch-from-chart`,
  [UiBlockType.DocumentTemplate]: `${basePath}/generate-document`, // TODO: fix this
  [UiBlockType.GenerateFile]: `${basePath}/generate-file`,
  [UiBlockType.GetInsurances]: `${basePath}/get-insurances`,
  [UiBlockType.UpdateFlowConfig]: `${basePath}/update-flow-config`,
  [UiBlockType.UpdateNotableObject]: `${basePath}/update-notable-object`,
  [UiBlockType.Conversation]: `${basePath}/conversation`,
  [UiBlockType.Fax]: `${basePath}/fax`,
  [UiBlockType.Form]: `${basePath}/form`,
  [UiBlockType.GetFormSet]: `${basePath}/get-form-set`,
  [UiBlockType.HumanTask]: `${basePath}/human-task`,
  [UiBlockType.SendEmail]: `${basePath}/send-email`,
  [UiBlockType.SendSms]: `${basePath}/send-sms`,
  [UiBlockType.VoiceCall]: `${basePath}/voice-call`,
  [UiBlockType.VoiceTranscribe]: `${basePath}/voice-transcribe`,
  [UiBlockType.Output]: `${basePath}/output`,
  [UiBlockType.AuthorizationSubmission]: `${basePath}/authorization-submission`,
  [UiBlockType.Fhir]: `${basePath}/fhir`,
  [UiBlockType.MedicalNecessityCheck]: `${basePath}/medical-necessity-check`,
  [UiBlockType.AdvancedFhir]: `${basePath}/advanced-fhir`,
  [UiBlockType.HieGetDocuments]: `${basePath}/hie-get-documents`,
  [UiBlockType.HieQueryDocuments]: `${basePath}/hie-query-documents`,
  [UiBlockType.Hl7]: `${basePath}/hl7-message-sender`,
  [UiBlockType.Mirth]: `${basePath}/interface-engine-message-sender`,
  [UiBlockType.RealTimeEligibility]: `${basePath}/real-time-eligibility-check`,
  [UiBlockType.Rest]: `${basePath}/rest-api`,
  [UiBlockType.Switch]: `${basePath}/conditional`,
  [UiBlockType.FilterList]: `${basePath}/filter-list`,
  [UiBlockType.Text]: `${basePath}/text`,
  [UiBlockType.IteratorV2]: `${basePath}/iterator`,
  [UiBlockType.IteratorV1]: `${basePath}/iterator-v1`,
  [UiBlockType.SubFlowV2]: `${basePath}/subflow`,
  [UiBlockType.WaitV2]: `${basePath}/wait`,
  [UiBlockType.CreatePatientOrder]: `${basePath}/create-patient-order`,
  [UiBlockType.Start]: `${basePath}/start`,
  [UiBlockType.DocumentExtract]: `${basePath}/document-extract`,
  [UiBlockType.CreateNotableObject]: `${basePath}/create-notable-object`,
  [UiBlockType.DocumentSearch]: `${basePath}/document-search`,
  [UiBlockType.ExportExternalDocumentPacket]: `${basePath}/export-document-packet`,
  [UiBlockType.ExportTextToBucket]: `${basePath}/export-to-the-cloud`,
  [UiBlockType.FileConversion]: `${basePath}/file-conversion`,
  [UiBlockType.SubFlowV1]: `${basePath}/flow`,
  [UiBlockType.GetExternalDocumentPacket]: `${basePath}/get-external-document-packet`,
  [UiBlockType.GetProvider]: `${basePath}/get-provider`,
  [UiBlockType.InsuranceCard]: `${basePath}/insurance-card`,
  [UiBlockType.AsynchronousExportJob]: `${basePath}/notable-classic-job`,
  [UiBlockType.RestApiClassicAuthorization]: `${basePath}/rest-api-notable-classic-auth`,
  [UiBlockType.Scheduling]: `${basePath}/scheduling`,
  [UiBlockType.ServiceReview]: `${basePath}/payor-communication-engine`,
  [UiBlockType.Callback]: `${basePath}/test-callback-wait`,
};
